import React, { useEffect } from "react";
import SideNav from "./SideNav";
import TopNav from "./TopNav";
import { useLocation, useNavigate } from "react-router-dom";
import getUserDetail from "../../utils/getUserDetail";

const Navigation = ({ setHamClick, hamClick }) => {
  const location = useLocation().pathname;
  const navigate = useNavigate();
  const user = getUserDetail();

  useEffect(() => {
    if (!user?.id) {
      navigate("/login");
    }
  }, [user, navigate]);

  if (location.includes("login")) {
    return null;
  }

  return (
    <div className="h-screen relative !duration-500 ">
      <TopNav hamClick={hamClick} setHamClick={setHamClick} />
      <SideNav hamClick={hamClick} setHamClick={setHamClick} />
    </div>
  );
};

export default Navigation;
